import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-delete-bulletin-modal',
  templateUrl: './delete-bulletin-modal.component.html',
  styleUrls: ['./delete-bulletin-modal.component.css']
})
export class DeleteBulletinModalComponent {
  @Input() bulletinHeader: string;

  constructor(private ngbActiveModal:NgbActiveModal) { }

  deleteClicked() {
    this.ngbActiveModal.close('delete');
  };

  cancelClicked() {
    this.ngbActiveModal.close('cancel');
  };

}
